import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const API_BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/blogs`;

  useEffect(() => {
    fetch(`${API_BASE}/${slug}`)
      .then((res) => res.json())
      .then((data) => setBlog(data.data));
  }, [slug]);

  if (!blog)
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500 text-lg">
        Loading article...
      </div>
    );

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex justify-center">

      <div className="max-w-3xl w-full px-6 py-12">

        {/* Top Gradient Line */}
        <div className="h-1 w-20 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full mb-6"></div>

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-4">
          {blog.title}
        </h1>

        {/* Meta */}
        <div className="flex items-center gap-3 text-sm text-gray-500 mb-6">
          <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center font-semibold">
            {blog.author?.[0] || "A"}
          </div>
          <div>
            <div className="font-medium text-gray-700">
              {blog.author || "Anonymous"}
            </div>
            <div className="text-xs text-gray-400">
              {new Date(blog.createdAt).toDateString()}
            </div>
          </div>
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-2 mb-8">
          {blog.tags?.map((tag, i) => (
            <span
              key={i}
              className="bg-blue-50 text-blue-600 text-xs px-3 py-1 rounded-full font-medium"
            >
              #{tag}
            </span>
          ))}
        </div>

        {/* Content */}
        <div
          className="prose prose-lg max-w-none text-gray-800 
                     prose-headings:text-gray-900 
                     prose-a:text-blue-600 
                     prose-strong:text-gray-900"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        {/* Divider */}
        <div className="my-12 border-t"></div>

        {/* CTA Card */}
        <div className="relative p-6 rounded-2xl border bg-white shadow-sm hover:shadow-md transition">

          {/* Gradient Border Effect */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-500 to-purple-500 opacity-10 blur-xl"></div>

          <div className="relative z-10">
            <h3 className="text-xl font-semibold mb-2">
              🚀 Practice Real Interviews
            </h3>
            <p className="text-gray-600 mb-4">
              Try AI-powered mock interviews on RealHired and get instant feedback.
            </p>

            <button className="px-5 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium hover:opacity-90 transition">
              Start Interview
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}